import AuthStore from '../../../../login/store/AuthStore';
import OptimizationStore from '../../../store/OptimizationStore';
import utils from './utils';
class Validator {
    valid = (formRef, data) => {
        let error = '';
        let validatons = new Validation();
        let keys = Object.keys(validatons);
        for (let i = 0; i <= keys.length; i++) {
            if (validatons[keys[i]] instanceof Function) {
                validatons[keys[i]](formRef, data)
            }
        }

        if (validatons.errorMessage.length > 0) {
            OptimizationStore.validateProduct(data.data.product_id, true)
            validatons.errorMessage.forEach((msg, index) => error += `${index + 1}) ${msg} `)
            AuthStore.setErrorModal(error)
        } else {
            OptimizationStore.validateProduct(data.data.product_id, false)
        }

        return validatons.errorMessage;

    }
}

class Validation {

    errorMessage = [];

    // ! Withdrawal Percentage Validation

    WithdrawalPercentageValidation = (formRef, productData) => {
    
        let asb_1 = formRef.$('accrual-of-survival-benefit').value.id
        let asb_2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
        let asb_3 = formRef.$('accrual-of-survival-benefits-year-3').value.id

        let asb_withdrawal_1 = formRef.$('withdrawal-parcentage-1').value.id
        let asb_withdrawal_2 = formRef.$('withdrawal-parcentage-2').value.id
        let asb_withdrawal_3 = formRef.$('withdrawal-parcentage-3').value.id
        
        if (Number(asb_1) === 6 && asb_withdrawal_1 === undefined) {
            this.errorMessage.push("Please select WithDrawal Parcentage (1st Opt In)")
        } 
        if (Number(asb_2) === 320 && asb_withdrawal_2 === undefined) {
            this.errorMessage.push("Please select WithDrawal Parcentage (2nd Opt In)")
        } 
        if (Number(asb_3) === 625 && asb_withdrawal_3 === undefined) {
            this.errorMessage.push("Please select WithDrawal Parcentage (3rd Opt In)")
        }
    }
}

export default new Validator();